export const commonGetIdMethod = (config) => {
  const defaultId = { id: '', idLayout: '', pageId: '' }
  if (config && typeof config === 'object') {
    if (config.id && typeof config.id === 'string') Object.assign(defaultId, { id: config.id })
    if (config.idLayout && typeof config.idLayout === 'string') Object.assign(defaultId, { idLayout: config.idLayout })
    if (config.pageId && typeof config.pageId === 'string') Object.assign(defaultId, { pageId: config.pageId })
  }

  return defaultId
}